var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0 fill-height d-flex align-center justify-center",attrs:{"fluid":""}},[(_vm.username==='QR-Code-Manager')?_c('generatoreQR',{staticStyle:{"height":"100%"}}):_c('timbratura')],1)}
var staticRenderFns = []

export { render, staticRenderFns }